export default __webpack_public_path__ + "static/media/ClaimProcessImage.477dd9ee.svg";